import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrossMedium"><Path d="M18.8105 6.25L13.0605 12L18.8105 17.75L17.75 18.8105L12 13.0605L6.25 18.8105L5.18945 17.75L10.9395 12L5.18945 6.25L6.25 5.18945L12 10.9395L17.75 5.18945L18.8105 6.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrossMedium;
